import { components } from 'react-select-3';

export const MultiValueRemove = props => {
  return <components.MultiValueRemove {...props}>×</components.MultiValueRemove>;
};
